export const PDFOptimizer = {
  "Modal": {
    "Title": "PDF Optimization",
    "Describe": "Reduce file size by compressing contents, unembedding fonts and discarding objects.",
    "PDFModalVersion": "Current PDF version: {pdfVersion}",
    "Footer": {
      "Cancel": "Cancel",
      "Ok": "OK",
      "RestoreDefault": "Restore Default"
    },
    "Compatible": "Make compatible with: "
  },
  "Content": {
    "PdfVersion": "PDF Version",
    "AuditSpaceUsage": "Audit space usage",
    "CompressImages": {
      "Title": "Color/Grayscale Images",
      "Options": {
        "Downsample": "Downsample",
        "BicubicDownsample": "Bicubic Downsampling",
        "SubSampling": "SubSampling",
        "AverageDownsampling": "Average Downsampling",
        "To": "to",
        "Off": "Off",
        "ForImagesAbove": "for images above",
        "Compression": "Compression",
        "RetainExisting": "Retain existing",
        "JPEG": "JPEG",
        "JPEG2000": "JPEG2000",
        "HighCompression": "High Compression",
        "Quality": "Quality",
        "Minimum": "Minimum",
        "Low": "Low",
        "Medium": "Medium",
        "High": "High",
        "Maximum": "Maximum",
        "PPI": "ppi",
        "ZIP": "ZIP",
        "TileSize": "Tile size:"
      }
    },
    "MonochromeImages": {
      "Title": "Monochrome Images",
      "Options": {
        "CompressImageDescribe": "Compress images only if there is a reduction in size",
        "JBIG2": "JBIG2",
        "CCITT3": "CCITT Group 3",
        "CCITT": "CCITT Group 4",
        "RunLength": "Run Length",
        "Lossless": "Lossless",
        "Lossy": "Lossy"
      }
    },
    "UnembedFonts": {
      "Title": "Unembed Fonts",
      "Subset": "Subset",
      "Options": {
        "UnembedFontsWarning": "Unembedded fonts may cause text to not be displayed as expected.",
        "EmbeddedFonts": "Embedded fonts",
        "FontsToUnembed": "Fonts to unembed"
      },
      "NotUnembed": "Subset all embedded fonts",
      "Unembed": "Unembed>>",
      "Retain": "<<Retain"
    },
    "DiscardObjects": {
      "Title": "Discard Objects",
      "Options": {
        "DiscardFormSubmissionDescribe": "Discard all form submission, import and reset actions",
        "FlattenFormFields": "Flatten form fields",
        "DiscardJavaScriptActions": "Discard all JavaScript actions",
        "DiscardPageThumbnails": "Discard embedded page thumbnails",
        "DiscardPrintSettings": "Discard embedded print settings",
        "DiscardBookmarks": "Discard bookmarks",
        "DiscardAll": "Discard all alternate images",
        "DiscardTags": "Discard document tags",
        "DetectMerge": "Detect and merge image fragments",
        "DiscardSearch": "Discard embedded search index"
      }
    },
    "DiscardUserData": {
      "Title": "Discard User Data",
      "Options": {
        "DiscardCommentsFormsMultimedia": "Discard all comments, forms and multimedia",
        "DiscardCrossReferences": "Discard external cross references",
        "DiscardInformationMetadata": "Discard document information and metadata",
        "DiscardAttachments": "Discard file attachments",
        "DiscardPrivateData": "Discard private data of other applications",
        "DiscardHiddenLayer": "Discard hidden layer content and flatten visible layers"
      }
    },
    "CleanUp": {
      "Title": "Clean Up",
      "Options": {
        "FlateNotEncoded": "Use Flate to encode streams that are not encoded",
        "FlateInstead": "In streams that use LZW encoding, use Flate instead",
        "RemoveBookmarks": "Remove invalid bookmarks",
        "RemoveLinks": "Remove invalid links",
        "Discard": "Discard unreferenced named destination",
        "Optimize": "Optimize the PDF for fast web view"
      }
    },
    "AuditSpace": {
      "Title": "Audit Space Usage",
      "Results": "Results",
      "Description": "Description",
      "Bytes": "Bytes",
      "Percentage": "Percentage",
      "Images": "Images",
      "ContentStreams": "Content Streams",
      "Fonts": "Fonts",
      "DocumentOverhead": "Document Overhead",
      "ColorSpaces": "Color Spaces",
      "Extended": "Extended Graphics States",
      "Cross": "Cross Reference Table",
      "Total": "Total",
      "AcroForms": "AcroForms",
      "CommentsAnd3D": "Comments and 3D Content",
      "EmbededFiles": "Embedded Files",
      "Bookmarks": "Bookmarks",
      "Structure": "Structure Info",
      "Piece": "Piece Information",
      "Link": "Link Annotations",
      "NamedDestnations": "Named Destinations",
      "PatternInfo": "Pattern Information",
      "ShadingPatternInfo": "Shading Information",
      "Thumb": "Thumbnails",
      "WebInfo": "Web Capture Information",
      "XObjectForms": "X Object Forms"
    },
    "OcrEngine": {
      "Title": "Select OCR Engine",
      "Settings": "Settings",
      "Supported": "Current Language Supported:",
      "Selected": "Selected languages(s):",
      "Searchable": "Searchable Text Image",
      "Editable": "Editable Text",
      "SearchableTip": {
        "Title": "Searchable Text Image",
        "Content": "The text can be searched but not allowed to be edited. The appearance of the PDF file will not change."
      },
      "EditableTip": {
        "Title": "Editable Text",
        "Content": "The PDF image text will be replaced with real text that can be edited with Foxit Editor Text & Paragraph Edit Content tool."
      }
    },
    "Reduce": {
      "Title": "Reduce File Size",
      "Compatibility": "PDF Version compatibility"
    },
    "Scanned": {
      "Title": "Optimize Scanned PDF",
      "nonImageContent": "Page contains non-image content, running scanned PDF optimization is not available.",
      "ImageOptions": {
        "Jpeg": "JPEG",
        "JpegLossless": "JPEG2000 (Lossless)",
        "JpegLossy": "JPEG2000 (Lossy)"
      },
      "MonoOptions": {
        "JbigLossless": "JBIG2 (Lossless)",
        "JbigLossy": "JBIG2 (Lossy)",
        "CcittGroup4": "CCITT Group4"
      },
      "PageRange": "Page Range",
      "CurrentPage": "Current page",
      "AllPage": "All pages",
      "Pages": "Pages:",
      "Sample": "Sample:1,5-9,12",
      "Optimize": "Optimize Options",
      "ColorGray": "Color/Gray: ",
      "LowQuality": "Low Quality: ",
      "HighQuality": "High Quality",
      "Monochrome": "Monochrome: ",
      "Deskew": "Deskew: ",
      "Version": "PDF Version Compatibility",
      "Searchable": "Make Searchable (run OCR)",
      "Options": "Options",
      "On": "On",
      "Off": "Off"
    }
  }
}
